import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { getApiRoute } from "src/services";

/** The viewer's most-recently-subscribed calendar they haven't reviewed, or null. */
export async function getReviewPromptCalendar() {
  const response = await axios.get(getApiRoute("calendar", "GET_REVIEW_PROMPT"), {
    withCredentials: true,
  });
  return response.data?.calendar ?? null;
}

/**
 * Fetches the calendar to feature in the review interstitial. Enable only when
 * the interstitial is otherwise eligible so it costs ~one request per fatigue
 * window rather than one per signed-in page load.
 *
 * Keyed by userId: signing out only clears AuthContext, so an unscoped key
 * would serve the previous account's calendar to the next one in the same tab.
 *
 * @param {{ userId?: string, enabled?: boolean }} options
 */
export const useReviewPromptCalendar = ({ userId, enabled = false } = {}) =>
  useQuery(["review-prompt-calendar", userId], getReviewPromptCalendar, {
    enabled: enabled && !!userId,
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });
